export default "__VITE_ASSET__23eMcrIm__"